var _svg;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HanaDark = function HanaDark(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _svg || (_svg = /*#__PURE__*/_jsxs("svg", {
      width: "24",
      height: "24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.254 10.252a4.127 4.127 0 1 1 0-8.253 4.127 4.127 0 0 1 0 8.253Z",
        fill: "#49F2E1"
      }), /*#__PURE__*/_jsx("path", {
        opacity: ".2",
        d: "M12.254 10.989a4.128 4.128 0 0 0-4.127 4.127v6.875h1.376a6.877 6.877 0 0 0 6.878-6.877 4.127 4.127 0 0 0-4.127-4.125Z",
        fill: "#49F2E1"
      })]
    }))
  });
};
export default HanaDark;